import type { ParsedTable } from "@/types/assesment";

export const permissionArray: string[] = [
  "add user",
  "get user",
  "get user list",
  "update user",
  "delete user",
  "add role",
  "get role",
  "get role list",
  "update role",
  "delete role",
  "delete permission",
  "add permission",
  "get permission",
  "get permission list",
  "get role permission list",
  "add role permission list",
  "get role permission",
  "update role permission",
  "delete role permission",
  "get category",
  "delete category",
  "get category list",
  "add category list",
  "update category",
  "update product",
  "add product",
  "get product",
  "get product list",
  "delete product",
  "delete product image",
  "get product image",
  "get product image list",
  "add product image",
  "update product image",
  "create single sub-category",
  "fetch single sub-category",
  "update single sub-category",
  "get sub-category list",
  "delete sub-category",
  "create single vendor",
  "delete single vendor",
  "get single vendor",
  "get vendor list",
  "update vendor list",
  "get dashboard analytics",
  "get top product",
  "get near expiry product",
  "get sales report",
  "update campaign status",
  "update vendor status",
  "get order list",
  "update order status",
  "update order payment status",
  "update order delivery status",
  "get delivery status of order",
];

export const saveToken = (token: string) => {
  if (token) {
    localStorage.setItem("access_token", token);
  }
};

export const getToken = (): string | null => {
  const token = localStorage.getItem("access_token");
  if (token === "null" || token === "undefined" || !token) return null;
  return token;
};

export const isTokenValid = (token: string | null): boolean => {
  if (!token || token === "null" || token === "undefined") return false;
  try {
    const parts = token.split(".");
    if (parts.length !== 3 || !parts[1]) return false;
    const payload = JSON.parse(atob(parts[1]));
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

interface UserData {
  email?: string;
  userId?: string;
  userName?: string;
  Permissions?: string[];
  [key: string]: any;
}
export const getCurrentUser = (key?: keyof UserData) => {
  const data = JSON.parse(localStorage.getItem("user") || "{}");
  if (!key) return data;
  return data[key];
};

export const clearOnLogout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("user");
  localStorage.setItem("cg-theme", "light");
};

export const combineClasses = (...classes: (string | undefined | false)[]) =>
  classes.filter(Boolean).join(" ");

export const env = (key: keyof ImportMetaEnv, defaultValue = ""): string => {
  const value = import.meta.env[key];
  return typeof value === "string" ? value : defaultValue;
};

export const requiredMessage = (name: string) => `${name} is required`;

export const onlyNumbersInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (["e", "E", "+", "-", "."].includes(e.key)) {
    e.preventDefault();
  }
};

export const capitalizeText = (text?: string) => {
  if (!text) return "";
  return text
    .split(" ")
    .map((word) => {
      const [first, ...rest] = word;
      return first ? first.toUpperCase() + rest.join("") : "";
    })
    .join(" ");
};

export const CURRENCY_SYMBOL = "₹";

export const getInitialValues = <T extends Record<string, any>>(config: T) =>
  Object.fromEntries(
    Object.entries(config).map(([key, val]) => [key, val.defaultValue])
  );

export const getSelectOptions = (arr?: { label: any; value: any }[]) =>
  (arr ?? []).map((item) => ({
    label: String(item.label),
    value: String(item.value),
  }));

export enum UserRole {
  OWNER = "OWNER",
  MANAGER = "MANAGER",
  EDITOR = "EDITOR",
}

export const USER_ROLES_OPTIONS = [
  { label: "Owner", value: "OWNER" },
  { label: "Manager", value: "MANAGER" },
  { label: "Editor", value: "EDITOR" },
];

export const createEnum = (obj: Record<string, any>) => {
  Object.freeze(obj);
};

export const dateConverter = (str: string | Date) => {
  const d = new Date(str);
  let mm = d.getMonth() + 1;
  let dd = d.getDate();

  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    d.getFullYear(),
  ].join("-");
};

export const inputDateFormat = (date?: string | Date) =>
  date ? new Date(date).toISOString().split("T")[0] : "";

export const updateParams = (
  params: Record<string, any>,
  setParams: React.Dispatch<React.SetStateAction<Map<string, any>>>
) => {
  setParams((prev) => {
    Object.entries(params || {}).forEach(([key, value]) => {
      prev.set(key, value);
    });
    return prev;
  });
};

export const addBaseUrl = (url?: string) => {  
  console.log( `${env("VITE_API_BASE_URL")}${url}`);
  
  return  `${env("VITE_API_BASE_URL")}${url}`;
};

export const checkPermission = (permission?: string) => {
  const permissions = getCurrentUser("permissions") || [];
  return permissions.includes(permission?.toLowerCase?.());
};

export const conditionalColumns = <T>(
  condition: boolean,
  columns: T[] | T
): T[] => {
  const colArray = Array.isArray(columns) ? columns : [columns];
  return condition ? colArray : [];
};

export const formatNumberWithSuffix = (value, roundDigits = 1) => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(roundDigits)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(roundDigits)}k`;
  return value.toString();
};


export const formatDate = (dateString) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "";

  return `${date.getFullYear()}/${String(
    date.getMonth() + 1
  ).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}`;
};

export const formatTime = (seconds: number) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  
  const formattedMin = m < 10 ? '0' + m : m;
  const formattedSec = s < 10 ? '0' + s : s;

  if (h > 0) {
    return `${h}:${formattedMin}:${formattedSec}`;
  }
  return `${formattedMin}:${formattedSec}`;
};


const formatDateTime = (date) => {
  if (!date) return null;

  return new Date(date).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true, 
  });
};

export const monacoMap: Record<string, string> = {
  javascript: "javascript",
  typescript: "typescript",
  python: "python",
  java: "java",
  "c++": "cpp",
  "c#": "csharp",
  c: "c",
  go: "go",
  html: "html",
  css: "css",
  json: "json",
  bash: "shell",
  sh: "shell",
  shell: "shell",
  kotlin: "kotlin",
  dart: "dart",
  r: "r",
  ruby: "ruby",
  rust: "rust",
  php: "php",
  sql: "sql",
  swift: "swift",
  scala: "scala",
  perl: "perl",
  lua: "lua",
  objectivec: "objective-c",
  "objective-c": "objective-c",
  fsharp: "fsharp",
  haskell: "haskell",
  clojure: "clojure",
  elixir: "elixir",
  erlang: "erlang",
  assembly: "assembly",
  prolog: "prolog",
  cobol: "cobol",
  lisp: "lisp",
  pascal: "pascal",
  "plain text": "plaintext",
  plaintext: "plaintext"
};

export const parseSchemaSql = (sql: string): ParsedTable[] => {
  if (!sql) return [];
  const tables: ParsedTable[] = [];

  const cleanSql = sql
    .replace(/--.*$/gm, '')
    .replace(/\/\*[\s\S]*?\*\//g, '');

  const createTableRegex = /CREATE\s+TABLE\s+(?:IF\s+NOT\s+EXISTS\s+)?(?:[`"']?(\w+)[`"']?)\s*\(([\s\S]*?)\)(?:\s*;|\s+ENGINE|\s*$)/gi;

  let match;
  while ((match = createTableRegex.exec(cleanSql)) !== null) {
    const tableName = match[1] || "";
    const columnDefinitions = match[2] || "";

    const columns: { name: string; type: string; constraints: string }[] = [];

    const columnLines: string[] = [];
    let currentLine = "";
    let parenCount = 0;

    for (let i = 0; i < columnDefinitions.length; i++) {
      const char = columnDefinitions[i];
      if (char === '(') parenCount++;
      if (char === ')') parenCount--;

      if (char === ',' && parenCount === 0) {
        columnLines.push(currentLine.trim());
        currentLine = "";
      } else {
        currentLine += char;
      }
    }
    if (currentLine.trim()) {
      columnLines.push(currentLine.trim());
    }

    for (const line of columnLines) {
      const upperLine = line.toUpperCase();
      if (
        upperLine.startsWith('PRIMARY KEY') ||
        upperLine.startsWith('FOREIGN KEY') ||
        upperLine.startsWith('CONSTRAINT') ||
        upperLine.startsWith('UNIQUE') ||
        upperLine.startsWith('KEY') ||
        upperLine.startsWith('INDEX')
      ) {
        continue;
      }

      const cleanLine = line.replace(/[`"']/g, '').trim();
      const parts = cleanLine.split(/\s+/);
      if (parts.length >= 2) {
        const colName = parts[0] || "";
        const colType = parts[1] || "";
        const colConstraints = parts.slice(2).join(' ') || "";
        columns.push({
          name: colName,
          type: colType,
          constraints: colConstraints
        });
      }
    }

    tables.push({ tableName, columns });
  }

  return tables;
};

export const parseSqlStdout = (stdout: string) => {
  if (!stdout) return { headers: [], rows: [] };

  // Split into lines
  const lines = stdout.split("\n").map(line => line.trim()).filter(line => line.length > 0);
  if (lines.length === 0) return { headers: [], rows: [] };

  const firstLine = lines[0];
  if (!firstLine) return { headers: [], rows: [] };

  // SQLite output format is typically column1|column2|column3
  // Check if first line contains pipes
  const hasPipes = firstLine.includes("|");

  let rows: string[][] = [];
  let headers: string[] = [];

  if (hasPipes) {
    rows = lines.map(line => line.split("|"));
    // Generate default headers (e.g. Column 1, Column 2...)
    const firstRow = rows[0];
    const colCount = firstRow ? firstRow.length : 0;
    headers = Array.from({ length: colCount }, (_, i) => `Col ${i + 1}`);
  } else {
    // If no pipes, it might be space-separated or tab-separated
    const hasTabs = firstLine.includes("\t");
    if (hasTabs) {
      rows = lines.map(line => line.split("\t"));
      const firstRow = rows[0];
      const colCount = firstRow ? firstRow.length : 0;
      headers = Array.from({ length: colCount }, (_, i) => `Col ${i + 1}`);
    } else {
      // Just single column per row
      rows = lines.map(line => [line]);
      headers = ["Result"];
    }
  }

  return { headers, rows };
};


export const parseTimeLimitToMinutes = (timeLimit: any): number => {
  if (timeLimit === null || timeLimit === undefined) return 120;

  if (typeof timeLimit === 'number') {
    return timeLimit > 0 ? timeLimit : 120;
  }

  const str = String(timeLimit).trim();
  if (/^\d+$/.test(str)) {
    const parsed = parseInt(str, 10);
    return parsed > 0 ? parsed : 120;
  }

  let minutes = 0;
  const hrMatch = str.match(/(\d+)\s*(hr|hour|h\b)/i);
  const minMatch = str.match(/(\d+)\s*(min|minute|m\b)/i);

  if (hrMatch) {
    minutes += parseInt(hrMatch[1] || "0", 10) * 60;
  }
  if (minMatch) {
    minutes += parseInt(minMatch[1] || "0", 10);
  }

  if (!hrMatch && !minMatch) {
    const parsed = parseInt(str, 10);
    return isNaN(parsed) || parsed <= 0 ? 120 : parsed;
  }

  return minutes > 0 ? minutes : 120;
};

export const parseTimeLimitToSeconds = (timeLimit: any): number => {
  if (timeLimit === null || timeLimit === undefined) return 120 * 60;

  if (typeof timeLimit === 'number') {
    return timeLimit > 0 ? timeLimit * 60 : 120 * 60;
  }

  const str = String(timeLimit).trim().toLowerCase();
  if (/^\d+$/.test(str)) {
    const parsed = parseInt(str, 10);
    return parsed > 0 ? parsed * 60 : 120 * 60;
  }

  let seconds = 0;
  const hrMatch = str.match(/(\d+)\s*(hr|hour|h\b)/i);
  const minMatch = str.match(/(\d+)\s*(min|minute|m\b)/i);
  const secMatch = str.match(/(\d+)\s*(sec|second|s\b)/i);

  let hasMatch = false;

  if (hrMatch) {
    seconds += parseInt(hrMatch[1] || "0", 10) * 3600;
    hasMatch = true;
  }
  if (minMatch) {
    seconds += parseInt(minMatch[1] || "0", 10) * 60;
    hasMatch = true;
  }
  if (secMatch) {
    seconds += parseInt(secMatch[1] || "0", 10);
    hasMatch = true;
  }

  if (!hasMatch) {
    const parsed = parseInt(str, 10);
    return isNaN(parsed) || parsed <= 0 ? 120 * 60 : parsed * 60;
  }

  return seconds > 0 ? seconds : 120 * 60;
};

export const getDatabaseType = (lang: any): string => {
  if (!lang) return "SQLITE";
  const name = (lang.name || lang.language || "").toLowerCase();
  const judge0Id = lang.judge0Id;

  if (judge0Id === 82 || name.includes("sqlite")) return "SQLITE";
  if (judge0Id === 34 || name.includes("postgres") || name.includes("postgresql")) return "POSTGRESQL";
  if (judge0Id === 33 || name.includes("mysql")) return "MYSQL";
  if (judge0Id === 32 || name.includes("mssql") || name.includes("sql server")) return "MSSQL";

  return "SQLITE";
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  if (navigator?.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.warn("navigator.clipboard copy failed, trying fallback:", err);
    }
  }

  // Fallback to older document.execCommand('copy') for non-secure HTTP contexts
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.width = "2em";
  textArea.style.height = "2em";
  textArea.style.padding = "0";
  textArea.style.border = "none";
  textArea.style.outline = "none";
  textArea.style.boxShadow = "none";
  textArea.style.background = "transparent";
  textArea.style.opacity = "0";
  
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    const successful = document.execCommand("copy");
    document.body.removeChild(textArea);
    return successful;
  } catch (err) {
    console.error("Fallback copy failed:", err);
    document.body.removeChild(textArea);
    return false;
  }
};

export const CODE_TEMPLATES: Record<string, string> = {
  javascript: `function solution(input) {
    // user code here

    return input;
}


// runner
const input = \`test input\`;

const output = solution(input);

console.log(output);`,

  typescript: `function solution(input: string): string {
    // user code here

    return input;
}


// runner
const input: string = "test input";

const output: string = solution(input);

console.log(output);`,

  python: `def solution(input):
    # user code here
    
    return input


input = """test input"""

output = solution(input)

print(output)`,

  java: `import java.util.Scanner; 
  
  public class Main {

    public static void main(String[] args) {

        Scanner sc = new Scanner(System.in);

        String input = "";

        if (sc.hasNextLine()) {
            input = sc.nextLine();
        }

        String output = solution(input);

        System.out.println(output);

        sc.close();
    }


    static String solution(String input) {
        // user code here

        return input;
    }
}`,

  cpp: `#include <iostream>
using namespace std;


string solution(string input) {

    // user code here

    return input;
}


int main() {

    string input = "test input";

    cout << solution(input);

    return 0;
}`,

  c: `#include <stdio.h>
#include <string.h>

void solution(char *input, char *output) {
    // write code here

    strcpy(output, input);
}


int main() {

    char input[10000] = "test input";
    char output[10000];

    solution(input, output);

    printf("%s", output);

    return 0;
}`
};

export const getTemplateForLanguage = (languageName = ""): string => {
  if (!languageName) return "";
  const name = languageName.toLowerCase();
  if (name.includes("typescript") || name.includes("ts")) {
    return CODE_TEMPLATES.typescript;
  }
  if (name.includes("javascript") || name.includes("node") || name.includes("js")) {
    return CODE_TEMPLATES.javascript;
  }
  if (name.includes("python")) {
    return CODE_TEMPLATES.python;
  }
  if (name.includes("java") && !name.includes("javascript")) {
    return CODE_TEMPLATES.java;
  }
  if (name.includes("c++") || name.includes("cpp")) {
    return CODE_TEMPLATES.cpp;
  }
  if (name.includes("c") && !name.includes("c++") && !name.includes("c#") && !name.includes("css") && !name.includes("cpp") && !name.includes("csharp")) {
    return CODE_TEMPLATES.c;
  }
  return "";
};

export const formatArrayInput = (input: string): string => {
  if (!input) return "";
  const trimmed = input.trim();
  if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
    return input;
  }
  const parts = trimmed.split(/[\s,]+/).filter(Boolean);
  return `[${parts.join(",")}]`;
};

export const stripBrackets = (input: string): string => {
  if (!input) return "";
  const trimmed = input.trim();
  if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
    return trimmed.substring(1, trimmed.length - 1).trim();
  }
  return input;
};